import React, { createContext, useRef, useMemo, useState } from 'react'
import { Scrollbars } from 'react-custom-scrollbars'
import classNames from 'classnames'
import SlidePanelHeader from './components/SlidePanelHeader'
import SlidePanelFooter from './components/SlidePanelFooter'
import { RightCevronIcon } from 'images/common'
import './style.scss'

export const SlidePanelScrollContext = createContext({ scrollToBottom: () => { } })

const SlidePanel = ({ isVisible, onClose, headerProps, footerProps, children, hasFadeOutScroll, noScroll, customFooter, color, size, onFullscreen, showFullscreen, contentClassName }) => {
  const scrollbarsRef = useRef(null)
  const [isFullscreen, setIsFullscreen] = useState(false)
  const [isOpen, setIsOpen] = useState(true)
  const [showFullscreenButton, setShowFullscreenButton] = useState(false)

  const scrollToBottom = () => {
    if (scrollbarsRef.current) {
      scrollbarsRef.current.scrollToBottom()
    }
  }

  const toggleFullscreen = () => {
    setIsFullscreen(!isFullscreen)
    onFullscreen && onFullscreen(!isFullscreen)
  }

  const closePanel = () => {
    setIsOpen(false)
    setTimeout(() => {
      onClose && onClose()
      setIsOpen(true)
    }, 500)
  }

  const contextValue = useMemo(() => ({ scrollToBottom }), [])
  const childrenClassName = classNames('viso-slide-panel__children', isFullscreen && 'viso-slide-panel__children--fullscreen', contentClassName)

  return (
    <SlidePanelScrollContext.Provider value={contextValue}>
      <div className='viso-slide-panel'>
        {isVisible && (
          <>
            <div
              className={classNames('overlay', isOpen && 'overlay_visible')}
              onClick={closePanel}
            />
            <div
              className={classNames(
                'viso-slide-panel__wrapper',
                isOpen && 'viso-slide-panel__wrapper--visible',
                size && `viso-slide-panel__wrapper--${size}`,
                isFullscreen && 'viso-slide-panel__wrapper--fullscreen'
              )}
              onMouseEnter={() => setShowFullscreenButton(true)}
              onMouseLeave={() => setShowFullscreenButton(false)}
            >
              {isOpen && showFullscreen && !isFullscreen && (
                <button
                  type='button'
                  className={classNames(
                    'viso-slide-panel__fullscreen',
                    showFullscreenButton && 'viso-slide-panel__fullscreen--visible'
                  )}
                  onClick={toggleFullscreen}
                >
                  <RightCevronIcon />
                </button>
              )}
              <div className='viso-slide-panel__content'>
                <SlidePanelHeader
                  onClose={closePanel}
                  headerProps={headerProps}
                  color={color}
                  isFullscreen={isFullscreen}
                  setIsFullscreen={setIsFullscreen}
                  onFullscreen={onFullscreen}
                />
                <div
                  className={classNames(
                    'viso-slide-panel__body',
                    hasFadeOutScroll && 'viso-slide-panel__body--fade-out'
                  )}
                >
                  {noScroll ? (
                    <div className={childrenClassName}>{children}</div>
                  ) : (
                    <Scrollbars
                      ref={scrollbarsRef}
                      style={{ width: '100%', height: 'auto', flexGrow: 1 }}
                      universal
                      autoHide
                      autoHideDuration={1}
                      renderThumbVertical={props => (
                        <div {...props} className='thumb-vertical' />
                      )}
                      renderView={props => (
                        <div
                          className='viso-scroll-wrap'
                          {...props}
                        />
                      )}
                    >
                      <div className={childrenClassName}>{children}</div>
                    </Scrollbars>
                  )}
                </div>
                {customFooter}
                {footerProps && <SlidePanelFooter footerProps={footerProps} />}
              </div>
            </div>
            <div id='slidePanelPopover' className='viso-popover-root' />
          </>
        )}
      </div>
    </SlidePanelScrollContext.Provider>
  )
}

export default SlidePanel